/**
 * Household Members Hook
 *
 * Fetches all active members of the current household.
 * Used by PerspectiveSwitcher to populate the member dropdown.
 */

import { useQuery } from '@tanstack/react-query';
import { fetchApi } from '@/shared/services';
import type { PaginatedResponse, UserRead } from '@/shared/types';

export const householdMemberKeys = {
  all: ['household-members'] as const,
  list: () => [...householdMemberKeys.all, 'list'] as const,
};

export function useHouseholdMembers() {
  return useQuery({
    queryKey: householdMemberKeys.list(),
    queryFn: async () => {
      const response = await fetchApi<PaginatedResponse<UserRead>>('/users');
      return response.items;
    },
    staleTime: 30 * 60 * 1000, // Low volatility — members rarely change
  });
}
